// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","footer":"App_footer__aawhi"};